import { __spreadArray } from "tslib";
import { useMemo, useEffect } from 'react';
import throttle from 'lodash/throttle';
import { useDeepEqualMemo } from '../useDeepEqualMemo';
/**
 * Returns a throttled version of the passed function.
 * Make sure your dep array is correct, linter doesn't work for custom hooks!!
 **/
export function useThrottle(func, dependencies, delay, options) {
    // memoize options so they don't throw off the throttle memo
    var memoizedOptions = useDeepEqualMemo(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttledFunction = useMemo(function () { return throttle(func, delay, memoizedOptions); }, __spreadArray(__spreadArray([], dependencies, true), [
        delay,
        memoizedOptions,
    ], false));
    useEffect(function () {
        return function () {
            throttledFunction.cancel();
        };
    }, [throttledFunction]);
    return throttledFunction;
}
//# sourceMappingURL=useThrottle.js.map